import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { Edit2, Trash2 } from "@piiqtechnologies/svg-icons";
import { PeekButton, PeekDivider, PeekIconButton, PeekStack, PeekTextField, PeekTooltip, PeekTypography, } from "@piiqtechnologies/ui-components";
import { useAnalytics } from "@piiqtechnologies/ui-lib";
import parentMessages from "../../messages.i18n";
import messages from "../messages.i18n";
const MAX_CHARACTERS = 80;
export const CommonRow = ({ subtopics, defaultCount, onEdit, onDelete, editingNewIndex, onEditingNewHandled, saveTrigger, category, onEditingCountChange, readOnly, hasBeenRun, }) => {
    const intl = useIntl();
    const analytics = useAnalytics();
    const [editingRows, setEditingRows] = useState({});
    useEffect(() => {
        onEditingCountChange === null || onEditingCountChange === void 0 ? void 0 : onEditingCountChange(Object.keys(editingRows).length);
    }, [editingRows, onEditingCountChange]);
    useEffect(() => {
        if (editingNewIndex !== null && editingNewIndex !== undefined) {
            setEditingRows((prev) => (Object.assign(Object.assign({}, prev), { [editingNewIndex]: { value: "", isNew: true } })));
            onEditingNewHandled === null || onEditingNewHandled === void 0 ? void 0 : onEditingNewHandled();
        }
    }, [editingNewIndex, onEditingNewHandled]);
    const prevSaveTriggerRef = useRef(saveTrigger);
    useEffect(() => {
        if (saveTrigger === prevSaveTriggerRef.current)
            return;
        prevSaveTriggerRef.current = saveTrigger;
        if (!saveTrigger)
            return;
        Object.entries(editingRows).forEach(([key, row]) => {
            const index = Number(key);
            const trimmed = row.value.trim();
            const isDefault = index < defaultCount;
            if (!trimmed && isDefault)
                return;
            onEdit === null || onEdit === void 0 ? void 0 : onEdit(index, trimmed);
        });
        setEditingRows({});
    }, [saveTrigger, editingRows, defaultCount, onEdit]);
    const handleStartEdit = (index) => {
        analytics.track("Custom Subtopics | Edit Clicked", { category, index });
        setEditingRows((prev) => (Object.assign(Object.assign({}, prev), { [index]: { value: subtopics[index], isNew: false } })));
    };
    const handleCancelEdit = (index) => {
        const row = editingRows[index];
        analytics.track("Custom Subtopics | Edit Cancelled", { category, isNewRow: row === null || row === void 0 ? void 0 : row.isNew });
        if (row === null || row === void 0 ? void 0 : row.isNew) {
            onEdit === null || onEdit === void 0 ? void 0 : onEdit(index, "");
        }
        setEditingRows((prev) => {
            const next = Object.assign({}, prev);
            delete next[index];
            return next;
        });
    };
    const handleChange = (index, newValue) => {
        if (newValue.length <= MAX_CHARACTERS) {
            setEditingRows((prev) => (Object.assign(Object.assign({}, prev), { [index]: Object.assign(Object.assign({}, prev[index]), { value: newValue }) })));
        }
    };
    const handleDelete = (index) => {
        analytics.track("Custom Subtopics | Subtopic Delete Clicked", { category, index });
        onDelete === null || onDelete === void 0 ? void 0 : onDelete(index);
    };
    return (React.createElement(React.Fragment, null, subtopics.map((subtopic, index) => {
        const isDefault = index < defaultCount;
        const editing = editingRows[index];
        return (React.createElement(React.Fragment, { key: `${index}-${subtopic}` },
            React.createElement(PeekStack, { direction: "row", justifyContent: "space-between", alignItems: "center", width: "100%" },
                React.createElement(PeekStack, { direction: "row", gap: 1, alignItems: "center", flex: 1 },
                    React.createElement(PeekTypography, { variant: "body1" },
                        index + 1,
                        "."),
                    editing ? (React.createElement(PeekTextField, { autoFocus: true, fullWidth: true, size: "small", value: editing.value, onChange: (e) => handleChange(index, e.target.value), inputProps: { maxLength: MAX_CHARACTERS } })) : (React.createElement(PeekTypography, { variant: "body1" }, subtopic))),
                editing ? (React.createElement(PeekStack, { direction: "row", gap: 1, px: 0.5, alignItems: "center" },
                    React.createElement(PeekTypography, { variant: "body1", color: "info.main" },
                        editing.value.length,
                        "/",
                        MAX_CHARACTERS),
                    React.createElement(PeekButton, { size: "small", variant: "text", color: "error", onMouseDown: (e) => e.preventDefault(), onClick: () => handleCancelEdit(index) }, intl.formatMessage(messages.cancelButton)))) : (!readOnly && (React.createElement(PeekStack, { direction: "row", gap: 0.5, alignItems: "center" },
                    React.createElement(PeekTooltip, { title: hasBeenRun ? (React.createElement(PeekTypography, { variant: "body1" }, intl.formatMessage(parentMessages.hasBeenRunTooltip, {
                            bold: (chunks) => React.createElement("span", { style: { fontWeight: 500 } }, chunks),
                            br: () => React.createElement("br", null),
                        }))) : (React.createElement(PeekTypography, { variant: "body1" }, intl.formatMessage(messages.editTooltip))) },
                        React.createElement("span", null,
                            React.createElement(PeekIconButton, { onClick: () => handleStartEdit(index), bordered: false, sx: { p: 0.5 }, disabled: hasBeenRun },
                                React.createElement(Edit2, { fontSize: 14 })))),
                    !isDefault && (React.createElement(PeekTooltip, { title: hasBeenRun ? (React.createElement(PeekTypography, { variant: "body1" }, intl.formatMessage(parentMessages.hasBeenRunTooltip, {
                            bold: (chunks) => React.createElement("strong", null, chunks),
                            br: () => React.createElement("br", null),
                        }))) : (React.createElement(PeekTypography, { variant: "body1" }, intl.formatMessage(messages.removeTooltip))) },
                        React.createElement("span", null,
                            React.createElement(PeekIconButton, { onClick: () => handleDelete(index), bordered: false, sx: { p: 0.5 }, disabled: hasBeenRun },
                                React.createElement(Trash2, { fontSize: 14 }))))))))),
            React.createElement(PeekDivider, { light: true })));
    })));
};
